module.exports = __webpack_public_path__ + "img/527.5db4d4ce.jpg";